import Toastify from 'toastify-js'

const showToastNotification = function(text, url = undefined, isError = false) {
  Toastify({
    text,
    duration: 3000,
    destination: url ? url : undefined,
    newWindow: false,
    close: true,
    gravity: 'top', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    backgroundColor: isError
      ? 'linear-gradient(to right, #d0011b, #960505)'
      : 'linear-gradient(to right, #3dafe7, #d8effa)',
    stopOnFocus: true, // Prevents dismissing of toast on hover
    //onClick: function(){} // Callback after click
  }).showToast()
}

export default showToastNotification
